import React from "react";
import { useRoutes } from "react-router-dom";

const Homepage = () => {

  
  return <div style={{width:"100%", height:"90vh", backgroundColor:"lightblue", display:"flex", justifyContent:"center", alignItems:"center", fontSize:"60px", fontWeight:"600"}}>
      HOME PAGE
    </div>
  
};

export default Homepage;